import React from "react";
import Section from "./Section";
import img1 from "../../img/25361.jpg";

export default function HTML_Images_Map() {
  return (
    <div className="tutorial-container">
      {/* 🔹 Title */}
      <h1 className="tutorial-title">🗺️ HTML Image Maps</h1>

      {/* 🔹 Introduction */}
      <p className="tutorial-intro">
        HTML Image Maps allow you to create <strong>clickable areas</strong>{" "}
        inside a single image. With the{" "}
        <code className="highlight_code_1">&lt;map&gt;</code> and
        <code className="highlight_code_1">&lt;area&gt;</code> tags, you can
        define different shapes like rectangles, circles, or polygons that lead
        to different links.
      </p>

      {/* 🔹 Key Points */}
      <div
        className="Key_point_container"
        style={{
          background: "linear-gradient(135deg, #f0f9ff, #e0f2fe)",
          borderRadius: "12px",
          padding: "1rem",
          marginBottom: "1.5rem",
        }}
      >
        <h3
          style={{
            color: "#0284c7",
            fontWeight: 700,
            fontSize: "1.5rem",
            marginBottom: "0.5rem",
          }}
        >
          📜 Common Image Map Attributes
        </h3>
        <ul className="tutorial-list-points">
          <li>
            <code className="highlight_code_1">usemap</code> — Connects the
            image to a map.
          </li>
          <li>
            <code className="highlight_code_1">&lt;map&gt;</code> — Defines the
            clickable areas.
          </li>
          <li>
            <code className="highlight_code_1">&lt;area&gt;</code> — Defines an
            interactive hotspot.
          </li>
          <li>
            <code className="highlight_code_1">shape</code> — rectangle / circle
            / poly.
          </li>
          <li>
            <code className="highlight_code_1">coords</code> — Coordinates of
            the clickable area.
          </li>
        </ul>
      </div>

      {/* Section 1️⃣ — Basic Image Map Example */}
      <Section
        title="1️⃣ Basic Image Map Example"
        html={`<img src="${img1}" alt="Image Map" usemap="#htmlMap" width="300" />

<map name="htmlMap">
  <area 
    shape="rect" 
    coords="0,0,150,150" 
    href="https://www.wikipedia.org" 
    alt="Wikipedia" 
    target="_blank" 
  />

  <area 
    shape="circle" 
    coords="220,80,40" 
    href="https://www.google.com" 
    alt="Google" 
    target="_blank" 
  />
</map>`}
        description="This example shows two clickable areas: a rectangle linked to Wikipedia and a circle linked to Google."
      />

      {/* Section 2️⃣ — Rectangle Area */}

      <Section
        title="2️⃣ Rectangle Area — Spot Example (Like Screenshot)"
        html={`<div style="position:relative; display:inline-block;">
  <img src="${img1}" alt="Laptop Image" width="300" style="display:block;" />

  <!-- 🔴 Red Spot -->
  <div style="
    position:absolute;
    top:80px;      /* adjust to match position */
    left:141px;     /* adjust to match position */
    width:18px;
    height:18px;
    border-radius:50%;
    border:4px solid red;
    background:transparent;
    z-index:10;
  "></div>

  <!-- 🟢 Vertical Line -->
  <div style="
    position:absolute;
    top:0;
    left:150px;     /* center aligned with the circle */
    width:2px;
    height:100%;
    background:#00ff00;
    z-index:5;
  "></div>

  <!-- 🟢 Horizontal Line -->
  <div style="
    position:absolute;
    top:88px;      /* align horizontally with circle center */
    left:0;
    width:100%;
    height:2px;
    background:#00ff00;
    z-index:5;
  "></div>
</div>`}
        description="This example visually marks a spot on the image using CSS — similar to your screenshot (red circle + green guidelines). Great for teaching coordinates in image maps."
      />
      <Section
        title="Girl Highlighted Area"
        html={`<div style="position:relative; display:inline-block;">
  <img src="${img1}" usemap="#girl-map" alt="Girl" width="350" style="display:block;" />

  <map name="girl-map">
    <!-- Marking ONLY the girl using your coords -->
    <area 
      shape="rect" 
      coords="34,44,270,350" 
      alt="Girl area" 
      style="outline:none;" 
    />
  </map>

  <!-- Blue highlight overlay at same coords -->
  <div style="
    position:absolute;
    left:170px;
    top:24px;
    width:156px;      /* 270 - 34 */
    height:210px;     /* 350 - 44 */
    background:rgba(0,123,255,0.35);
    pointer-events:none;
    border-radius:6px;
  "></div>
</div>`}
        description="Blue highlight and clickable map focusing only on the girl, avoiding background."
      />

      {/* Summary */}
      <div
        style={{
          background: "linear-gradient(135deg, #fef9c3, #fde68a)",
          padding: "1rem",
          borderRadius: "12px",
          marginTop: "2rem",
        }}
      >
        <h2>📘 Summary — HTML Image Maps</h2>
        <ul className="tutorial-list-points">
          <li>Create clickable hotspots on an image using image maps.</li>
          <li>Supported shapes: rectangle, circle, polygon.</li>
          <li>
            Use <code>coords</code> to define clickable region size and
            position.
          </li>
          <li>Use external JS (image-map-resizer) for responsiveness.</li>
        </ul>
      </div>
    </div>
  );
}
